﻿import "jquery";
import "script-loader!../../lib/layerslider/js/greensock.js";
import "script-loader!../../lib/layerslider/js/layerslider.transitions.js";
import "script-loader!../../lib/layerslider/js/layerslider.kreaturamedia.jquery.js";
import "../../sass/site/site.scss";

// Preloader
window.addEventListener("load", function() {
    $("#pre-status").fadeOut();
    $("#st-preloader").delay(250).fadeOut("slow");
    $("div.body-content > div.alert").delay(2000).slideUp("slow");
});


// Slider
var setOptions = function (e) {

    // Set Options.
    return {
        responsiveUnder: 960,
        layersContainer: 960,
        fitScreenWidth: !$(e).hasClass("green"),
        skin: "v5",
        skinsPath: "lib/layerslider/skins/",
        navButtons: false,
        navStartStop: false,
        hoverPrevNext: $(e).hasClass("green"),
        showCircleTimer: false
    };

};
window.addEventListener("load", function () { return $("div.layer-slider-white").each(function (i, e) { return $(e).layerSlider(setOptions(e)); }); });


//////////////////
// WEBPACK FOOTER
// ../site/preload.js
// module id = 512
// module chunks = 2